// S-Lab
export const SLAB_STRAINS = [
  {
    id: "slab-baltic-haze-22",
    name: "Baltic Haze",
    producer: "S-Lab",
    country: "Kolumbia",
    genetics: "Hybryda/Sativa",
    thc: 22, cbd: 0,
    availability: "Brak",
    aromas: ["Cytrusowy", "Owocowy"],
    description: "Hybryda z dominantą sativa o proporcjach 70:30 od S-LAB - nie tylko dzięki dominującemu kariofilenowi, ale ze względu na synergię wszystkich terpenów w jej profilu wykazuje silne działanie przeciwzapalne oraz przeciwbólowe. Susz jest bogaty w limonen, nadający mu charakterystyczny, energetyzujący, cytrusowy aromat, dodatkowo działając przeciwlękowo, wraz z obecnym w leku linalolem. Limonen dodatkowo ma udokumentowane właściwości łagodzenia dyskomfortu i niepokoju po zbyt wysokich dawkach THC, co sprawia, że odmiana będzie odpowiednia nawet dla początkujących Pacjentów.",
    descriptionEn: "A sativa-dominant hybrid with a 70:30 ratio from S-LAB, exhibiting strong anti-inflammatory and analgesic effects not only thanks to its dominant caryophyllene, but also due to the synergy of all terpenes in its profile. The flower is rich in limonene, which gives it a characteristic, energising citrus aroma and also has an anxiolytic effect alongside the linalool present in the medicine. Limonene additionally has documented properties in alleviating discomfort and anxiety following excessively high doses of THC, making the strain suitable even for patients who are new to cannabis therapy.",
    terpenes: { kariofilen: 27, limonen: 19, ocymen: 6, linalol: 7, humulen: 9 },
    dominantTerpene: "Kariofilen", packaging: "15 g"
  },
  {
    id: "slab-pink-kush",
    name: "Pink Kush",
    producer: "S-Lab",
    country: "Portugalia",
    genetics: "Indica",
    lineage: "OG Kush × Hindu Kush",
    thc: 18, cbd: 1.0,
    availability: "Wysoka", effect: "Relaksujące",
    aromas: ["Korzenny", "Pieprzowy", "Pikantny", "Ziemisty"],
    description: "Indica z krzyżowania OG Kush i Hindu Kush. Nerolidol i bisabolol powodują głęboki relaks, uspokojenie i senność oraz silne odprężenie ciała.",
    terpenes: { nerolidol: 6, kariofilen: 5, bisabolol: 2, humulen: 1 },
    dominantTerpene: "Nerolidol", packaging: "15g"
  },
  {
    id: "slab-cataract-kush-18",
    name: "Cataract Kush",
    producer: "S-Lab",
    country: "Portugalia",
    genetics: "Indica",
    lineage: "LA Confidential × OG Kush",
    thc: 18, cbd: 1.0,
    availability: "Wysoka", effect: "Relaksujące",
    aromas: ["Drzewny", "Owocowy", "Pikantny", "Słodki", "Ziemisty", "Ziołowy"],
    description: "Cataract Kush to indica o klasycznym, kushowym charakterze, powstała z połączenia LA Confidential i OG Kush. Dominujący mircen odpowiada za głęboki relaks mięśniowy i działanie sedatywne, wspierając sen i redukując napięcie. Kariofilen — wiążąc się bezpośrednio z receptorami CB2 — zapewnia silne działanie przeciwzapalne i przeciwbólowe. Limonen może wywoływać początkową euforię i poprawę nastroju.",
    terpenes: { mircen: 28, kariofilen: 20, limonen: 17, linalol: 9, pinen: 14, humulen: 6 },
    dominantTerpene: "Mircen", packaging: "15g"
  },
  {
    id: "slab-pink-kush-22",
    name: "Pink Kush",
    producer: "S-Lab",
    country: "Portugalia",
    genetics: "Indica",
    lineage: "OG Kush × Hindu Kush",
    thc: 22, cbd: 1.0,
    availability: "Wysoka", effect: "Relaksujące",
    aromas: ["Korzenny", "Pieprzowy", "Pikantny", "Ziemisty"],
    description: "Indica z THC 22% z krzyżowania OG Kush i Hindu Kush. Nerolidol i bisabolol powodują głęboki relaks, uspokojenie i senność oraz silne odprężenie ciała.",
    terpenes: { nerolidol: 6, kariofilen: 5, bisabolol: 2, humulen: 1 },
    dominantTerpene: "Nerolidol", packaging: "15g"
  },
  {
    id: "slab-triangle-mints-22",
    name: "Triangle Mints",
    producer: "S-Lab",
    country: "Portugalia",
    genetics: "Hybryda/Sativa",
    lineage: "Triangle Kush × Animal Mints",
    thc: 22, cbd: 1.0,
    availability: "Wysoka", effect: "Pobudzające",
    aromas: ["Korzenny", "Ziemisty", "Ziołowy"],
    description: "Hybryda sativa ze skrzyżowania Triangle Kush i Animal Mints. Dominujący kariofilen (ok. 40% profilu terpenowego) zapewnia silne działanie przeciwzapalne i przeciwbólowe poprzez bezpośrednią aktywację receptorów CB2. Farnezen, mircen i humulen dopełniają profil, nadając suszu korzenno-ziemisty charakter i wzmacniając efekt entourage.",
    terpenes: { kariofilen: 40, farnezen: 20, mircen: 20, humulen: 20 },
    dominantTerpene: "Kariofilen", packaging: "15g"
  },
  {
    id: "slab-purps-18",
    name: "Purps",
    producer: "S-Lab",
    country: "Portugalia",
    genetics: "Hybryda/Indica",
    lineage: "nieznany rodowód",
    thc: 18, cbd: 1.0,
    availability: "Wysoka", effect: "Zrównoważone",
    aromas: ["Korzenny", "Kwiatowy", "Owocowy", "Ziemisty"],
    description: "Purps to hybrydowa odmiana od S-Lab z przewagą genów indica (ok. 70%), wyróżniająca się głębokim, uspokajającym działaniem i intensywnym aromatem. Dzięki wysokiej zawartości limonenu i linalolu oferuje odprężenie i poprawę nastroju. Właściwości relaksacyjne i poprawiające jakość snu susz zawdzięcza nerolidolowi, mircenowi i linalolowi.",
    terpenes: { nerolidol: 24, kariofilen: 25, limonen: 11, bisabolol: 11, linalol: 8, mircen: 6, pinen: 5, humulen: 9, ocymen: 1 },
    dominantTerpene: "Kariofilen", packaging: "15g"
  },
  {
    id: "slab-galaxy-walker-og-18",
    name: "Galaxy Walker OG",
    producer: "S-Lab",
    country: "Portugalia",
    genetics: "Hybryda/Indica",
    lineage: "nieznany rodowód",
    thc: 18, cbd: 1.0,
    availability: "Wysoka", effect: "Relaksujące",
    aromas: ["Korzenny", "Miętowy", "Pikantny", "Sosnowy"],
    description: "Indica od firmy S-Lab z niezwykle bogatym profilem terpenowym. Wyraźna obecność nerolidolu oraz kariofilenu przekłada się na silne właściwości przeciwbólowe, przeciwzapalne i antyspastyczne. Limonen i linalol wspierają poprawę nastroju. Zbilansowane połączenie fizycznego odprężenia i jasności umysłu. Pacjenci doceniają właściwości przeciwbólowe odmiany, m.in. w bólu pooperacyjnym i przewlekłym.",
    terpenes: { nerolidol: 30, linalol: 7, mircen: 6, pinen: 4, humulen: 7, kariofilen: 26, limonen: 8, bisabolol: 12 },
    dominantTerpene: "Nerolidol", packaging: "15g"
  },
  {
    id: "slab-galaxy-walker-og-22",
    name: "Galaxy Walker OG",
    producer: "S-Lab",
    country: "Portugalia",
    genetics: "Hybryda/Indica",
    lineage: "nieznany rodowód",
    thc: 22, cbd: 1.0,
    availability: "Brak", effect: "Relaksujące",
    aromas: ["Korzenny", "Miętowy", "Pikantny", "Sosnowy"],
    description: "Indica od firmy S-Lab z niezwykle bogatym profilem terpenowym. Wyraźna obecność nerolidolu oraz kariofilenu przekłada się na silne właściwości przeciwbólowe, przeciwzapalne i antyspastyczne. Limonen i linalol wspierają poprawę nastroju. Zbilansowane połączenie fizycznego odprężenia i jasności umysłu.",
    terpenes: { nerolidol: 30, linalol: 7, mircen: 6, pinen: 4, humulen: 7, kariofilen: 26, limonen: 8, bisabolol: 12 },
    dominantTerpene: "Nerolidol", packaging: "15g"
  },
  {
    id: "slab-animintz-22",
    name: "Animintz",
    producer: "S-Lab",
    country: "Portugalia",
    genetics: "Hybryda/Indica",
    lineage: "Animal Mintz × Purp Skurp",
    thc: 22, cbd: 1.0,
    availability: "Wysoka", effect: "Relaksujące",
    aromas: ["Cytrusowy", "Kwiatowy", "Słodki", "Ziemisty", "Ziołowy"],
    description: "Hybryda indica (ok. 70/30) ze skrzyżowania Animal Mintz i Purp Skurp. Aromat łączy nuty ziemiste, cytrusowe i kwiatowe. Dominujące terpeny: linalol, kariofilen, mircen i limonen. Polecana na popołudnie i wieczór — przynosi spokój, wyciszenie i relaks. Pacjenci zgłaszają początkowe pobudzenie, późniejszą relaksację i senność.",
    terpenes: { linalol: 25, kariofilen: 25, mircen: 25, limonen: 25 },
    dominantTerpene: "Linalol", packaging: "15g"
  },
  {
    id: "slab-spiced-latte",
    name: "Spiced Latte",
    producer: "S-Lab",
    country: "Portugalia",
    genetics: "Hybryda/Sativa",
    lineage: "Jean Guy × Alien Dawg",
    thc: 18, cbd: 1.0,
    availability: "Wysoka", effect: "Pobudzające",
    aromas: ["Cytrusowy", "Korzenny", "Sosnowy", "Ziemisty"],
    description: "Hybryda sativa (80/20) ze skrzyżowania Jean Guy i Alien Dawg. Profil terpenowy bogaty w kariofilen oraz mircen, linalol i humulen. Dodatkowo zawartość limonenu powoduje zwiększenie energii i działanie aktywizujące.",
    terpenes: { kariofilen: 46, limonen: 8, linalol: 6, mircen: 7, humulen: 13 },
    dominantTerpene: "Kariofilen", packaging: "15g"
  },
  {
    id: "slab-spiced-latte-22",
    name: "Spiced Latte",
    producer: "S-Lab",
    country: "Portugalia",
    genetics: "Hybryda/Sativa",
    lineage: "Jean Guy × Alien Dawg",
    thc: 22, cbd: 1.0,
    availability: "Brak", effect: "Pobudzające",
    aromas: ["Cytrusowy", "Korzenny", "Sosnowy", "Ziemisty"],
    description: "Hybryda sativa (80/20) ze skrzyżowania Jean Guy i Alien Dawg. Profil terpenowy bogaty w kariofilen oraz mircen, linalol i humulen. Dodatkowo zawartość limonenu powoduje zwiększenie energii i działanie aktywizujące.",
    terpenes: { kariofilen: 46, limonen: 8, linalol: 6, mircen: 7, humulen: 13 },
    dominantTerpene: "Kariofilen", packaging: "15g"
  },
  {
    id: "slab-pink-certz",
    name: "Pink Certz",
    producer: "S-Lab",
    country: "Portugalia",
    genetics: "Hybryda/Sativa",
    lineage: "The Menthol × Grape Gasoline",
    thc: 18, cbd: 1.0,
    availability: "Wysoka", effect: "Pobudzające",
    aromas: ["Diesel", "Miętowy", "Lukrecjowy"],
    description: "Hybryda sativa (ok. 80/20) ze skrzyżowania The Menthol i Grape Gasoline. Dominujące terpeny to nerolidol, limonen i kariofilen. Ma działanie pobudzające i sprzyjające koncentracji, powoduje skupienie i przypływ energii.",
    terpenes: { nerolidol: 27, humulen: 12, kariofilen: 14, limonen: 14 },
    dominantTerpene: "Nerolidol", packaging: "15g"
  },
  {
    id: "slab-pink-certz-22",
    name: "Pink Certz",
    producer: "S-Lab",
    country: "Portugalia",
    genetics: "Hybryda/Sativa",
    lineage: "The Menthol × Grape Gasoline",
    thc: 22, cbd: 1.0,
    availability: "Wysoka", effect: "Pobudzające",
    aromas: ["Diesel", "Miętowy", "Lukrecjowy"],
    description: "Hybryda sativa (ok. 80/20) ze skrzyżowania The Menthol i Grape Gasoline. Dominujące terpeny to nerolidol, limonen i kariofilen. Ma działanie pobudzające i sprzyjające koncentracji, powoduje skupienie i przypływ energii.",
    terpenes: { nerolidol: 27, limonen: 14, kariofilen: 14, humulen: 12 },
    dominantTerpene: "Nerolidol", packaging: "15g"
  },
  {
    id: "slab-animal-rntz",
    name: "Animal Rntz",
    producer: "S-Lab",
    country: "Portugalia",
    genetics: "Hybryda/Indica",
    lineage: "Animal Cookies × Runtz",
    thc: 18, cbd: 1.0,
    availability: "Wysoka", effect: "Relaksujące",
    aromas: ["Kwaśny", "Owocowy", "Słodki", "Ziemisty"],
    description: "Hybryda o proporcjach 60:40 z przewagą indici. W profilu terpenowym dominują kariofilen i limonen, co powoduje relaksacyjny efekt, bez nadmiernej senności czy trudności z koncentracją.",
    terpenes: { kariofilen: 30, limonen: 14, linalol: 11, pinen: 8, humulen: 8 },
    dominantTerpene: "Kariofilen", packaging: "15g"
  },
  {
    id: "slab-lilac-diesel",
    name: "Lilac Diesel",
    producer: "S-Lab",
    country: "Portugalia",
    genetics: "Hybryda/Sativa",
    lineage: "nieznany rodowód",
    thc: 22, cbd: 1.0,
    availability: "Wysoka", effect: "Pobudzające",
    aromas: ["Cytrusowy", "Diesel", "Kwiatowy", "Lawendowy"],
    description: "Hybryda sativa (60:40) od S-Lab. Działa zarówno pobudzająco i poprawiająco nastrój, jak i przeciwbólowo i wspierająco funkcje poznawcze. Odpowiednia na godziny poranne i wczesne popołudnie. Pacjenci potwierdzają zasadność stosowania odmiany w ciągu dnia, delikatne działanie aktywizujące, ale bez \"natłoku myśli\" i bez pogorszenia jakości snu.",
    terpenes: { terpinolen: 23, mircen: 8, pinen: 7, kariofilen: 8, limonen: 6, bisabolol: 3, humulen: 3 },
    dominantTerpene: "Terpinolen", packaging: "15g"
  },
  {
    id: "slab-lilac-diesel-18",
    name: "Lilac Diesel",
    producer: "S-Lab",
    country: "Portugalia",
    genetics: "Hybryda/Sativa",
    lineage: "nieznany rodowód",
    thc: 18, cbd: 1.0,
    availability: "Brak", effect: "Pobudzające",
    aromas: ["Cytrusowy", "Diesel", "Kwiatowy", "Lawendowy"],
    description: "Hybryda sativa (60:40) od S-Lab. Działa zarówno pobudzająco i poprawiająco nastrój, jak i przeciwbólowo i wspierająco funkcje poznawcze. Odpowiednia na godziny poranne i wczesne popołudnie.",
    terpenes: { terpinolen: 23, mircen: 8, pinen: 7, kariofilen: 8, limonen: 6, bisabolol: 3, humulen: 3 },
    dominantTerpene: "Terpinolen", packaging: "15g"
  },
  {
    id: "slab-mimosa",
    name: "Mimosa",
    producer: "S-Lab",
    country: "Portugalia",
    genetics: "Hybryda/Sativa",
    lineage: "Clementine × Purple Punch",
    thc: 22, cbd: 1.0,
    availability: "Wysoka", effect: "Pobudzające",
    aromas: ["Cytrusowy", "Drzewny", "Owocowy", "Ziemisty"],
    description: "Hybryda sativa (70/30) o THC 22%. Dominują działania pobudzające, energetyzujące, motywujące do podejmowania aktywności. Mimo przewagi Sativy, w wyższych dawkach może oferować fizyczne odprężenie. Pacjenci zgłaszają lekkie pobudzenie i poprawę koncentracji.",
    terpenes: { kariofilen: 25, pinen: 23, limonen: 11, linalol: 8 },
    dominantTerpene: "Kariofilen", packaging: "15g"
  },
  {
    id: "slab-sherbert-scotti-18",
    name: "Sherbert Scotti",
    producer: "S-Lab",
    country: "Portugalia",
    genetics: "Hybryda/Indica",
    lineage: "Sunset Sherbert × Biscotti",
    thc: 18, cbd: 1.0,
    availability: "Wysoka", effect: "Relaksujące",
    aromas: ["Cytrusowy", "Deserowy", "Słodki"],
    description: "Odmiana wyróżnia się bardzo bogatym profilem terpenowym, w którym dominuje kariofilen — terpen znany z silnego działania przeciwzapalnego. Właściwość tę wzmacnia dodatkowo obecność mircenu i pinenu. Nerolidol i linalol tworzą natomiast kompozycję o działaniu uspokajającym i relaksującym, sprzyjającą głębokiemu, regenerującemu snu.",
    terpenes: { kariofilen: 27, linalol: 15, nerolidol: 12, farnezen: 4, pinen: 5, mircen: 3, ocymen: 3, limonen: 2 },
    dominantTerpene: "Kariofilen", packaging: "15g"
  },
  {
    id: "slab-beach-crasher-22",
    name: "Beach Crasher",
    producer: "S-Lab",
    country: "Portugalia",
    genetics: "Hybryda/Indica",
    lineage: "White Widow × Wedding Crasher",
    thc: 22, cbd: 1.0,
    availability: "Wysoka", effect: "Relaksujące",
    aromas: ["Pieprzowy", "Sosnowy", "Ziemisty"],
    description: "Hybryda indica o wyraźnej przewadze genów indica - ok. 80% do 20%. Powstała z krzyżówki Wedding Crasher oraz TK BX1. Działa przeciwzapalnie i przeciwbólowo dzięki synergistycznemu działaniu kariofilenu i humulenu, powoduje głęboką miorelaksację i zmniejszenie napięcia. Pacjenci zgłaszają głęboką relaksację i senność po ok. 30 min od waporyzacji.",
    terpenes: { kariofilen: 43, limonen: 13, bisabolol: 5, linalol: 9, pinen: 5, humulen: 11 },
    dominantTerpene: "Kariofilen", packaging: "15g"
  },
  {
    id: "slab-beach-crasher-18",
    name: "Beach Crasher",
    producer: "S-Lab",
    country: "Portugalia",
    genetics: "Hybryda/Indica",
    lineage: "White Widow × Wedding Crasher",
    thc: 18, cbd: 1.0,
    availability: "Wysoka", effect: "Relaksujące",
    aromas: ["Pieprzowy", "Sosnowy", "Ziemisty"],
    description: "Hybryda indica od S-Lab o zawartości THC 18%. Powoduje głębokie odprężenie i wyciszenie, odpowiednia do stosowania w godzinach wieczornych. Synergistyczne działanie humulenu i kariofilenu odpowiada za silny efekt przeciwbólowy i przeciwzapalny.",
    terpenes: { kariofilen: 43, limonen: 13, bisabolol: 5, linalol: 9, pinen: 5, humulen: 11 },
    dominantTerpene: "Kariofilen", packaging: "15g"
  },
  {
    id: "slab-wappa-22",
    name: "Wappa",
    producer: "S-Lab",
    country: "Portugalia",
    genetics: "Hybryda/Indica",
    lineage: "nieznany rodowód",
    thc: 22, cbd: 1.0,
    availability: "Brak", effect: "Relaksujące",
    aromas: ["Drzewny", "Owocowy", "Słodki"],
    description: "Dominujący kariofilen odpowiada za działanie przeciwzapalne i przeciwbólowe, co potęguje mircen, któremu odmiana zawdzięcza właściwości poprawiające jakość snu. Efekt uspokajający wzmaga obecny w suszu linalol. Pacjenci zgłaszają początkowe pobudzenie i aktywizację, a po ok. godzinie uczucie relaksacji i senności.",
    terpenes: { kariofilen: 34, mircen: 20, pinen: 16, humulen: 10, linalol: 5 },
    dominantTerpene: "Kariofilen", packaging: "15g"
  },
  {
    id: "slab-wedding-pie-22",
    name: "Wedding Pie",
    producer: "S-Lab",
    country: "Portugalia",
    genetics: "Hybryda/Indica",
    lineage: "Wedding Cake × Grape Pie",
    thc: 22, cbd: 1.0,
    availability: "Wysoka", effect: "Relaksujące",
    aromas: ["Kwaśny", "Owocowy", "Ziemisty"],
    description: "Wedding Pie to hybryda z przewagą genów indica (60/40) od S-Lab, powstała ze skrzyżowania Wedding Cake i Grape Pie, co nadaje jej intensywny, słodko-owocowy charakter. Dominujące w profilu terpenowym to kariofilen, mircen i linalol odpowiadające za relaksujące, wyciszające i poprawiające jakość snu działanie suszu. Pacjenci potwierdzają silne działanie nasenne tej odmiany.",
    terpenes: { kariofilen: 28, mircen: 22, limonen: 18, linalol: 16, humulen: 16 },
    dominantTerpene: "Kariofilen", packaging: "15g"
  },
  {
    id: "slab-lemon-haze-gelato-18",
    name: "Lemon Haze Gelato",
    producer: "S-Lab",
    country: "Portugalia",
    genetics: "Hybryda/Sativa",
    lineage: "Lemon Haze × Gelato",
    thc: 18, cbd: 1.0,
    availability: "Wysoka", effect: "Pobudzające",
    aromas: ["Cytrusowy", "Owocowy", "Słodki"],
    description: "Hybryda o proporcjach 70:30 działa energetyzująco i aktywizująco, dzięki wysokiej zawartości limonenu, któremu susz zawdzięcza swój charakterystyczny zapach. To również on powoduje efekt przeciwdepresyjny i pobudzający, szczególnie odpowiedni dla Pacjentów z obniżonym napędem. Dominujący w profilu terpenowym humulen wykazuje właściwości analgetyczne, co docenią Pacjenci będący w terapii konopnej z powodu dolegliwości bólowych. Odmiana wykazuje dodatkowo właściwości przeciwzapalne, za co odpowiada kariofilen, a mircen zmniejsza napięcie mięśniowe i redukuje stres, co jest odczuwalne po kilku godzinach.",
    terpenes: { humulen: 36, kariofilen: 29, guaiol: 9, limonen: 7, mircen: 4 },
    dominantTerpene: "Humulen", packaging: "15g"
  },
  {
    id: "slab-jack-herrer-18",
    name: "Jack Herrer",
    producer: "S-Lab",
    country: "Portugalia",
    genetics: "Sativa",
    lineage: "Northern Lights × Shiva Skunk × Haze",
    thc: 18, cbd: 1.0,
    availability: "Brak", effect: "Pobudzające",
    aromas: ["Miętowy", "Pieprzowy", "Pikantny"],
    description: "Mimo przynależności do sativ, dominujący w profilu terpenowym mircen będzie powodował uspokojenie i wyciszenie. Polecana dla osób szukających skupienia się bez nadmiernej sedacji.",
    terpenes: { mircen: 40, nerolidol: 20, pinen: 8, kariofilen: 9 },
    dominantTerpene: "Mircen", packaging: "15g"
  },
  {
    id: "slab-rockstar-18",
    name: "Rockstar",
    producer: "S-Lab",
    country: "Portugalia",
    genetics: "Indica",
    lineage: "Rockbud × Sensi Star",
    thc: 18, cbd: 1.0,
    availability: "Brak", effect: "Relaksujące",
    aromas: ["Słodki", "Owocowy", "Miętowy"],
    description: "Indica z dominującym nerolidolem w profilu terpenowym, który powoduje działanie nasenne i uspokajające. Dodatkowo jest to terpen o udokumentowanym pozytywnym działaniu przeciwzapalnym w chorobach reumatycznych, np. RZS, co nasili drugi działający przeciwzapalnie i obecny w suszu składnik, kariofilen. Limonen będzie powodował początkową aktywizację i pobudzenie i redukował lęk, synergistycznie z bisabololem. Pacjenci zwracają uwagę na przypływ energii przy stosowaniu niższych dawek, i efekt sedujący dopiero po zwiększonym spożyciu oraz zwracają uwagę na zwiększony apetyt jako skutek uboczny.",
    terpenes: { nerolidol: 24, linalol: 8, mircen: 6, humulen: 8, kariofilen: 23, limonen: 8, bisabolol: 12 },
    dominantTerpene: "Nerolidol", packaging: "15g"
  },
  {
    id: "slab-rockstar-22",
    name: "Rockstar",
    producer: "S-Lab",
    country: "Portugalia",
    genetics: "Indica",
    lineage: "Rockbud × Sensi Star",
    thc: 22, cbd: 1.0,
    availability: "Wysoka", effect: "Relaksujące",
    aromas: ["Słodki", "Owocowy", "Miętowy"],
    description: "Indica z dominującym nerolidolem w profilu terpenowym, który powoduje działanie nasenne i uspokajające. Dodatkowo jest to terpen o udokumentowanym pozytywnym działaniu przeciwzapalnym w chorobach reumatycznych, np. RZS, co nasili drugi działający przeciwzapalnie i obecny w suszu składnik, kariofilen. Limonen będzie powodował początkową aktywizację i pobudzenie i redukował lęk, synergistycznie z bisabololem. Pacjenci zgłaszają początkowe pobudzenie, dopiero późniejszą sedację i działanie analgetyczne.",
    terpenes: { nerolidol: 24, linalol: 8, mircen: 6, humulen: 8, kariofilen: 23, limonen: 8, bisabolol: 12 },
    dominantTerpene: "Nerolidol", packaging: "15g"
  },
  {
    id: "slab-master-kush-18",
    name: "Master Kush",
    producer: "S-Lab",
    country: "Portugalia",
    genetics: "Indica",
    lineage: "Hindu Kush × Skunk",
    thc: 18, cbd: 1.0,
    availability: "Wysoka", effect: "Relaksujące",
    aromas: ["Korzenny", "Pieprzowy", "Ziemisty"],
    description: "Indica, dzięki wysokiej zawartości nerolidolu i towarzyszącemu mu linalolowi będzie poprawiała jakość snu i ułatwiała zasypianie. Za działanie przeciwbólowe i przeciwzapalne odpowiadają dominujący kariofilen i humulen.",
    terpenes: { nerolidol: 24, linalol: 4, pinen: 2, humulen: 4, kariofilen: 26, limonen: 8, bisabolol: 10 },
    dominantTerpene: "Kariofilen", packaging: "15g"
  },
  {
    id: "slab-master-kush-22",
    name: "Master Kush",
    producer: "S-Lab",
    country: "Portugalia",
    genetics: "Indica",
    lineage: "Hindu Kush × Skunk",
    thc: 22, cbd: 1.0,
    availability: "Wysoka", effect: "Relaksujące",
    aromas: ["Korzenny", "Pieprzowy", "Ziemisty"],
    description: "Indica, dzięki wysokiej zawartości nerolidolu i towarzyszącemu mu linalolowi będzie poprawiała jakość snu i ułatwiała zasypianie. Za działanie przeciwbólowe i przeciwzapalne odpowiadają dominujący kariofilen i humulen. Przez Pacjentów opisywana jako znacząco poprawiająca łaknienie i bardzo uspokajająca.",
    terpenes: { nerolidol: 24, linalol: 4, pinen: 2, humulen: 4, kariofilen: 26, limonen: 8, bisabolol: 10 },
    dominantTerpene: "Kariofilen", packaging: "15g"
  },
  {
    id: "slab-biscuit-rntz-22",
    name: "Biscuit Rntz",
    producer: "S-Lab",
    country: "Portugalia",
    genetics: "Hybryda/Indica",
    lineage: "nieznany rodowód",
    thc: 22, cbd: 1.0,
    availability: "Wysoka", effect: "Relaksujące",
    aromas: ["Słodki", "Owocowy", "Ziemisty"],
    description: "Hybryda/indica o proporcjach 60:40. Kariofilen odpowiada za działanie przeciwzapalne i przeciwbólowe. Linalol synergistycznie działa analgetycznie i daje efekt uspokajający i przeciwlękowy.",
    terpenes: { kariofilen: 30, limonen: 14, linalol: 11, pinen: 8, humulen: 5 },
    dominantTerpene: "Kariofilen", packaging: "15g"
  },
  {
    id: "slab-frosted-cherry-cookies-22",
    name: "Frosted Cherry Cookies",
    producer: "S-Lab",
    country: "Portugalia",
    genetics: "Hybryda/Indica",
    lineage: "nieznany rodowód",
    thc: 22, cbd: 1.0,
    availability: "Wysoka", effect: "Relaksujące",
    aromas: ["Cytrusowy", "Jagodowy", "Sosnowy", "Ziołowy"],
    description: "Dominujący mircen odpowiada za działanie relaksujące i sedacyjne. Humulen i pinen wykazują działanie synergistyczne, zmniejszając stan zapalny. Humulen jako jeden z nielicznych terpenów może zmniejszać apetyt, a limonen we wstępnych badaniach ma potwierdzone działanie obniżające masę ciała, co może sprawić, że ta odmiana będzie wybierana przez Pacjentów narzekających na zwiększone łaknienie jako skutek uboczny terapii.",
    terpenes: { mircen: 27, pinen: 27, kariofilen: 11, limonen: 8, humulen: 6 },
    dominantTerpene: "Mircen", packaging: "15g"
  },
  {
    id: "slab-island-sweet-skunk-22",
    name: "Island Sweet Skunk",
    producer: "S-Lab",
    country: "Portugalia",
    genetics: "Sativa",
    lineage: "nieznany rodowód",
    thc: 22, cbd: 1.0,
    availability: "Wysoka", effect: "Pobudzające",
    aromas: ["Słodki", "Cytrusowy", "Owocowy", "Mango"],
    description: "Przez Pacjentów uważana za jedną z najsilniejszych sativ na polskim rynku, zgłaszają silną aktywizację i gadatliwość, zwiększoną gadatliwość i (niekażdorazowo) natłok myśli.",
    terpenes: { nerolidol: 10, mircen: 7, pinen: 19, humulen: 8, kariofilen: 15, limonen: 4, ocymen: 2, terpinolen: 14, bisabolol: 9 },
    dominantTerpene: "Pinen", packaging: "15g"
  },
  {
    id: "slab-headband-22",
    name: "Headband",
    producer: "S-Lab",
    country: "Portugalia",
    genetics: "Hybryda",
    lineage: "OG Kush × Sour Diesel",
    thc: 22, cbd: 1.0,
    availability: "Wysoka", effect: "Zrównoważone",
    aromas: ["Cytrusowy", "Diesel", "Drzewny"],
    description: "Headband to hybryda powstała z krzyżowania OG Kush i Sour Diesel, oferująca długotrwałe łagodzenie bólu, relaksację ciała oraz skuteczną redukcję stresu. Dominujący nerolidol zapewnia silne działanie uspokajające i przeciwbólowe, które potęguje kariofilen. Bisabolol wzmacnia efekt relaksujący, a limonen wspiera poprawę nastroju i działa przeciwdepresyjnie. Nazwa pochodzi od uczucia opaski na głowie zaraz po inhalacji. Pacjenci potwierdzają działanie przeciwbólowe i korzystny wpływ na dolegliwości gastrologiczne.",
    terpenes: { nerolidol: 25, kariofilen: 21, bisabolol: 16, limonen: 9, humulen: 9 },
    dominantTerpene: "Nerolidol", packaging: "15g"
  },
  {
    id: "slab-northern-berry-22",
    name: "Northern Berry",
    producer: "S-Lab",
    country: "Portugalia",
    genetics: "Hybryda/Indica",
    lineage: "Northern Lights #5 × Blueberry",
    thc: 22, cbd: 1.0,
    availability: "Wysoka", effect: "Relaksujące",
    aromas: ["Cytrusowy", "Jagodowy", "Owocowy"],
    description: "Hybryda/indica o proporcjach 80:20 o silnym działaniu przeciwzapalnym i poprawiającym jakość snu, za co odpowiadają kariofilen i mircen, dominujące w profilu terpenowym. Mimo tego, część Pacjentów zgłasza początkową aktywizację, która potem przechodzi w uczucie wyciszenia i relaksacji. Dodatkowo Pacjenci cenią odmianę za jej skuteczność w eliminowaniu bólu i jagodowo-borówkowy aromat.",
    terpenes: { kariofilen: 45, mircen: 17, humulen: 17, ocymen: 4, terpinolen: 1, bisabolol: 2, nerolidol: 3, linalol: 3 },
    dominantTerpene: "Kariofilen", packaging: "15g"
  }
];